<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12" class="mb-8">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-flex xs12 md4 lg4>
										<v-card-title class="pa-2">{{
											$t('titles.equipmentInformations')
										}}</v-card-title>
									</v-flex>
									<v-flex class="d-flex justify-end">
										<v-btn
											v-if="inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-flex>
								</v-row>
								<v-row wrap>
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:readonly="true"
												v-model="equipment.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="equipment.inventory_number"
												:errorBorder="!equipmentValidation.inventory_number"
												:label="$t('fields.inventoryNumber')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="equipment.name"
												:errorBorder="!equipmentValidation.name"
												:label="'* ' + $t('fields.name')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="equipment.equipment_type_id"
												:ajax="true"
												:data="'equipment-types'"
												:errorBorder="!equipmentValidation.equipment_type_id"
												:label="'* ' + $t('fields.equipmentType')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												v-model="equipment.entry_date"
												:errorBorder="!equipmentValidation.entry_date"
												:date-label="$t('fields.entryDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12" v-if="!equipment.classroom_id && $route.params.id != 0">
											<CheckBox
												:readonly="!inEditMode"
												v-model="equipment.write_off"
												:label="$t('fields.writeOff')"
											></CheckBox>
										</v-col>
										<v-col cols="12" v-if="equipment.write_off">
											<DatePicker
												:readonly="!inEditMode && equipment.write_off"
												v-model="equipment.write_off_date"
												:errorBorder="!equipmentValidation.write_off_date"
												:date-label="$t('fields.writeOffDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12" v-if="equipment.classroom_name != null">
											<InputField
												:disabled="true"
												v-model="equipment.classroom_name"
												:errorBorder="!equipmentValidation.classroom_name"
												:label="$t('fields.classroom')"
											></InputField>
										</v-col>
									</v-flex>
									<v-flex v-if="equipment.id != 0 && !inEditMode" lg6 xs12 sm12>
										<div :class="['text-h6', 'pl-4', 'pa-2', 'pb-0']">
											{{ $t('labels.activities') }}
										</div>
										<Activities :equipmentId="$route.params.id"></Activities>
									</v-flex>
								</v-row>
								<v-row wrap>
									<v-col cols="12" v-if="$route.params.id != 0 && !inEditMode">
										<v-row>
											<v-col cols="12" v-if="$myStore.state.user.user_role_id == 1">
												<v-btn color="primary" @click="openModal">
													{{ $t('buttons.newInspection') }}&nbsp;&nbsp;<v-icon small
														>fa-plus</v-icon
													>
												</v-btn>
												<Modal :show-modal="modalOpen">
													<template v-slot:title>
														<div :class="['text-h5', 'pa-4']">
															{{ $t('buttons.newInspection') }}
														</div>
													</template>
													<Inspection
														@close="closeModal"
														:inEditMode="true"
														:inspection="newInspection"
														:newInspection="true"
													>
													</Inspection>
												</Modal>
											</v-col>
										</v-row>
										<v-row>
											<v-col cols="12">
												<Inspections
													:inEquipmentEditMode="inEditMode"
													:equipmentId="$route.params.id"
												></Inspections>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Equipment from '../../../models/Equipment';
import InspectionModel from '../../../models/Inspection';
import Dropdown from '../../trinkets/Dropdown';
import DatePicker from '../../trinkets/DatePicker';
import Inspections from './Inspections';
import Inspection from './Inspection';
import Modal from '../../trinkets/Modal';
import Activities from './Activities';

export default {
	name: 'Equipment',
	components: {
		CheckBox,
		InputField,
		Dropdown,
		DatePicker,
		Inspections,
		Modal,
		Inspection,
		Activities,
	},
	data: function () {
		return {
			equipment: new Equipment({ id: this.$route.params.id, entry_date: new Date().toISOString().slice(0, 10) }),
			equipmentValidation: new Equipment({}, true),
			newInspection: null,
			initialLoad: false,
			inEditMode: false,
			lockKey: 'equipment',
			lockTimer: null,
			modalOpen: false,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.equipment.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.equipment.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},

		backClick() {
			this.$router.go(-1);
		},
		openModal() {
			this.newInspection = new InspectionModel({ equipment_id: this.$route.params.id });
			this.modalOpen = true;
		},
		closeModal() {
			this.newInspection = {};
			this.modalOpen = false;
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.equipment.name == null || this.equipment.name == '') {
				success = false;
				this.equipmentValidation.name = false;
			} else {
				if (this.equipment.name.length > 50) {
					this.equipmentValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.equipmentValidation.name = true;
				}
			}

			if (!this.equipment.equipment_type_id) {
				success = false;
				this.equipmentValidation.equipment_type_id = false;
			} else {
				this.equipmentValidation.equipment_type_id = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.equipment.id != 0) {
					action = 'put';
					addition = '/' + vm.equipment.id;
				}
				this.$APICall(action, 'equipments' + addition, this.equipment, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.equipment.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.equipment.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.equipment.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.equipment.id != 0) {
			this.$APICall('get', 'equipments/' + this.equipment.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.equipment = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.equipments'),
							href: '/#/equipments',
							disabled: false,
						},
						{
							text: vm.equipment.name + ' (' + vm.equipment.id + ')',
							href: '/#/equipments/' + vm.equipment.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.equipments'),
					href: '/#/equipments',
					disabled: false,
				},
				{
					text: this.$t('modules.newEquipment'),
					href: '/#/equipments/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
